import Badge from '@atlaskit/badge';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import Store from '../../../../store';
import NotificationsStore from '../../../../store/notificationsStore';

interface Props {
  notificationsStore: NotificationsStore;
}

type ComponentProps = Props & InjectedIntlProps;

interface ComponentState {
  ready: boolean;
}

@observer
class NotificationsBadge extends React.Component<ComponentProps, ComponentState> {
  state: ComponentState = {
    ready: false,
  };

  componentDidMount() {
    this.props.notificationsStore.countUnseenNotifications();
  }

  render() {
    const { notificationsStore } = this.props;
    if (notificationsStore.unseenCount <= 0) {
      return null;
    }
    return (
      <Badge max={9} appearance="important">
        {notificationsStore.unseenCount}
      </Badge>
    );
  }
}

export default inject(({ notificationsStore }: Store) => ({
  notificationsStore,
}))(injectIntl(NotificationsBadge));
